import React, { useEffect, useState } from "react";
import API_BASE_URL from "../config";

const TermsConditionsPopup = () => {

    const [showPopup, setShowPopup] = useState(false);
    const [terms, setTerms] = useState([]);
    const [agreed, setAgreed] = useState(false);
    const [loadingTerms, setLoadingTerms] = useState(true);
    const [checkingTerms, setCheckingTerms] = useState(true);


    useEffect(() => {

        const token = localStorage.getItem("token");

        fetch(`${API_BASE_URL}/api/terms/all`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(res => res.json())
            .then(data => {
                setTerms(data);
                setLoadingTerms(false); // terms loaded
            })
            .catch(err => {
                console.log("Terms load error", err);
                setLoadingTerms(false);
            });

    }, []);


    useEffect(() => {

        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");

        if (!token || !userId) return;

        fetch(`${API_BASE_URL}/api/terms/check/${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(res => res.json())
            .then(data => {

                if (!data.accepted) {
                    setShowPopup(true);
                }

                setCheckingTerms(false);

            })
            .catch(err => {
                console.log("Terms check error", err);
                setCheckingTerms(false);
            });

    }, []);

    useEffect(() => {
        if (showPopup) {
            document.body.style.overflow = "hidden"; // disable scroll
        } else {
            document.body.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
        };
    }, [showPopup]);


    useEffect(() => {
        if (showPopup) {
            setAgreed(false);
        }
    }, [showPopup]);


    const acceptTerms = async () => {

        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");

        try {

            const res = await fetch(`${API_BASE_URL}/api/terms/accept/${userId}`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (!res.ok) {
                throw new Error("Failed to accept terms");
            }

            setShowPopup(false);

        } catch (err) {
            console.error("Accept terms error:", err);
            alert("Unable to accept terms. Please try again.");
        }
    };



    if (checkingTerms || loadingTerms || !showPopup || terms.length === 0) return null;


    return (
        <div style={overlayStyle}>
            <div style={popupStyle}>

                <div style={headerStyle}>
                    <h3 style={{ margin: 0 }}>Terms & Conditions</h3>
                </div>

                <div style={termsContent}>
                    <p>
                        Please review and accept the terms and conditions before continuing to use the system.
                    </p>

                    <ul>
                        {terms.map(term => (
                            <li key={term.id}>{term.text}</li>
                        ))}
                    </ul>

                    <div style={{ marginTop: "15px" }}>

                        <label style={checkboxStyle}>
                            <input
                                type="checkbox"
                                checked={agreed}
                                onChange={(e) => setAgreed(e.target.checked)}
                            />
                            I have read and agree to the Terms & Conditions.
                        </label>

                    </div>
                </div>

                <div style={footerStyle}>
                    <button
                        style={{
                            ...btnStyle,
                            opacity: agreed ? 1 : 0.5,
                            cursor: agreed ? "pointer" : "not-allowed"
                        }}
                        onClick={acceptTerms}
                        disabled={!agreed}
                    >
                        Accept & Continue
                    </button>
                </div>

            </div>
        </div>
    );
};

const overlayStyle = {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.6)",
    backdropFilter: "blur(4px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999999
};

const popupStyle = {
    background: "#fff",
    borderRadius: "12px",
    width: "min(750px, 90vw)",   // responsive width
    maxHeight: "85vh",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 15px 40px rgba(0,0,0,0.25)",
    animation: "fadeIn 0.3s ease"
};

const headerStyle = {
    padding: "20px 25px",
    borderBottom: "1px solid #eee",
    fontWeight: "600"
};

const termsContent = {
    padding: "20px 25px",
    overflowY: "auto",
    maxHeight: "450px",   // more readable space
    lineHeight: "1.6",
    fontSize: "14px",
    color: "#444"
};

const footerStyle = {
    padding: "15px 25px",
    borderTop: "1px solid #eee",
    display: "flex",
    justifyContent: "flex-end"
};

const btnStyle = {
    padding: "10px 22px",
    background: "linear-gradient(135deg,#007bff,#0056d2)",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "0.2s",
    boxShadow: "0 4px 10px rgba(0,123,255,0.4)"
};

const checkboxStyle = {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "10px",
    fontSize: "14px",
    cursor: "pointer"
};

export default TermsConditionsPopup;